module.exports = __webpack_public_path__ + "img/Honduras.3dff2375.png";